export default {
  name: "ProAgeEvent",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
